var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w-full h-52 bg-gray-100 flex justify-items-center text-gray-500 font-bold text-3xl text-center"},[_vm._v(" Matkortet ")])}
var staticRenderFns = []

export { render, staticRenderFns }